/**
 * Google Auth Service - Handles Google authentication
 */
const googleAuthService = {
  /**
   * Initialize Google API client
   * @returns {Promise} Resolves when Google API is initialized
   */
  initGoogleApi: () => {
    return new Promise((resolve, reject) => {
      // Check if gapi is already loaded
      if (window.gapi && window.gapi.client) {
        resolve(window.gapi);
        return;
      }

      // Load the Google API client
      window.gapi.load('client:auth2', () => {
        window.gapi.client
          .init({
            discoveryDocs: [
              'https://people.googleapis.com/$discovery/rest?version=v1',
            ],
            clientId: '551586398920-cpk7un4cut3kgvo4ocusoqfjcpf8oeif.apps.googleusercontent.com',
            scope: 'profile email',
          })
          .then(
            () => {
              resolve(window.gapi);
            },
            (error) => {
              console.error('Error initializing Google API:', error);
              reject(error);
            },
          );
      });
    });
  },

  /**
   * Sign in with Google
   * @returns {Promise} Resolves to Google user data
   */
  signInWithGoogle: async () => {
    try {
      // Initialize Google API if not already initialized
      await googleAuthService.initGoogleApi();

      // Configure sign-in options
      const options = new window.gapi.auth2.SigninOptionsBuilder();
      options.setPrompt('select_account');

      // Sign in with Google
      await window.gapi.auth2.getAuthInstance().signIn(options);

      // Get user profile information
      const response = await window.gapi.client.people.people.get({
        'resourceName': 'people/me',
        'requestMask.includeField': 'person.names,person.email_addresses,person.metadata',
      });

      // Get access token
      let accessToken = '';
      if (window.gapi.auth2.getAuthInstance().currentUser &&
          window.gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse()) {
        accessToken = window.gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse().id_token;
      }

      // Extract user data
      const userData = {
        id: response.result.metadata.sources.find(source => source.type === 'PROFILE')?.id || '',
        email: response.result.emailAddresses[0].value,
        name: response.result.names[0].displayName,
        provider_token: accessToken,
      };

      return userData;
    } catch (error) {
      console.error('Error signing in with Google:', error);
      throw error;
    }
  },

  /**
   * Sign out from Google
   * @returns {Promise} Resolves when signed out
   */
  signOutFromGoogle: async () => {
    try {
      if (window.gapi && window.gapi.auth2) {
        await window.gapi.auth2.getAuthInstance().signOut();
      }
    } catch (error) {
      console.error('Error signing out from Google:', error);
      throw error;
    }
  },
};

export default googleAuthService;